var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading && _vm.isNativePlatform)?_c('div',{class:[_vm.$style.loading]},[(_vm.isNativePlatform)?_c('component-loading-spinner'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }